// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"40e63a93","796":"6063236f"}[chunkId] + ".chunk.js";
};